import React, { useContext, useState } from "react";


import useUrlParams from "../../../../../customHooks/useUrlParams";
import { junctionStatusOptions } from "../../../../../utils/constants";

import { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro";
import useLabels from "../../../../../customHooks/useLabels";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  TABLE_ROW_HEIGHT
} from "../../../../../styles/Variables";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";


import { MapsContext } from "../../maps/context/context";
import { mapsPayloadType } from "../../maps/context/reducer";
const JunctionStatusList = () => {
  const [activeItemId, setActiveItemId] = useState(0);

  const { state,dispatch } = useContext(MapsContext);


  const rows1: GridValidRowModel[] = junctionStatusOptions.map((res, index) => ({
    id: index + 1,
    description: res.label,
    ItemId: res.value,
  }));
  
  const { itemLabel } = useLabels();
  const columns: GridColDef[] = [
    {
      headerName: itemLabel,
      cellClassName: "td-link",
      field: "description",
      headerAlign: HEADER_TEXT_ALIGN,
      flex: FlexForColumns.DESCRIPTION,
      hideable: false
    }
  ];


  return (
    <>
      <div className="asset-reports__left--list">
          <StyledDatagrid
            getCellClassName={(params) =>
              params.row.ItemId === activeItemId ? "active" : ""
            }
            columns={columns}
            rows={rows1}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            hideFooter
            onRowClick={(params) => {
              dispatch({
                type: mapsPayloadType.JUNCTION_STATUS,
                payload: {
                  junctionStatus: params.row.ItemId,
                },
              });
            
              setActiveItemId(params.row.ItemId);
            }}
          />
     
      </div>
    </>
  );
};

export default JunctionStatusList;
